import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-top-up-confirm-code',
    templateUrl: './top-up-confirm-code.component.html',
    styleUrls: ['./top-up-confirm-code.component.scss']
})
export class TopUpConfirmCodeComponent {

    @Input() topupCode?: string;
    @Input() topupAmount?: number;
    @Input() topupCurrency?: string;
    @Input() incorrectAccount?: boolean;
    @Output() goBackEmit = new EventEmitter<string>();
    @Output() submitEmit = new EventEmitter<string>();

    constructor() {
    }

    goBack() {
        this.goBackEmit.emit('Code');
    }

    onSubmit() {
        this.submitEmit.emit('Succeess');
    }
}
